export const ESTADO_CENTERS: Record<string, [number, number]> = {
  "Acre": [-9.02, -70.81],
  "Alagoas": [-9.57, -36.78],
  "Amapá": [1.41, -51.77],
  "Amazonas": [-3.47, -65.10],
  "Bahia": [-12.96, -38.51],
  "Ceará": [-5.20, -39.53],
  "Distrito Federal": [-15.78, -47.93],
  "Espírito Santo": [-19.19, -40.34],
  "Goiás": [-16.64, -49.31],
  "Maranhão": [-5.42, -45.44],
  "Mato Grosso": [-12.64, -55.42],
  "Mato Grosso do Sul": [-20.51, -54.54],
  "Minas Gerais": [-18.10, -44.38],
  "Pará": [-3.79, -52.48],
  "Paraíba": [-7.12, -36.72],
  "Paraná": [-24.89, -51.55],
  "Pernambuco": [-8.28, -35.07],
  "Piauí": [-7.72, -42.73],
  "Rio de Janeiro": [-22.84, -43.15],
  "Rio Grande do Norte": [-5.81, -36.59],
  "Rio Grande do Sul": [-30.03, -51.23],
  "Rondônia": [-11.22, -62.80],
  "Roraima": [2.82, -60.67],
  "Santa Catarina": [-27.33, -49.44],
  "São Paulo": [-23.55, -46.63],
  "Sergipe": [-10.57, -37.45],
  "Tocantins": [-10.25, -48.25],
};

export const BIOMA_CENTERS: Record<string, [number, number]> = {
  "Amazônia": [-3.4653, -62.2159],
  "Caatinga": [-9.0, -40.0],
  "Cerrado": [-15.5, -47.8],
  "Mata Atlântica": [-20.5, -41.5],
  "Pampa": [-31.0, -53.0],
  "Pantanal": [-17.5, -56.5],
};